import React, { useState, useEffect } from 'react'; // eslint-disable-line no-unused-vars
import { Typography, Link, Avatar, Grid, Paper } from '@mui/material';
import type { Charity } from '@types';
import * as consts from '@utilities/consts';
import { getCharity } from '@utilities/actions';

export interface CharityCardProps {
  charityId: string;
  variant: 'full' | 'link';
}

export const CharityCard = ({ charityId, variant }: CharityCardProps): React.JSX.Element | null => {
  const [charity, setCharity] = useState<Charity | null>(null);

  useEffect(() => {
    const fetchData = async () => {
      let charityResponse: Charity | null = await getCharity(charityId);
      setCharity(charityResponse);
    };
    if (charityId) {
      fetchData();
    }
  }, [charityId]);

  const navigateToCharity = (charityId: string) => {
    window.location.href = `${consts.URL_CHARITY}?${consts.QUERYPARAMETER_CHARITYID}=${charityId}`;
  };

  const renderFull = () => {
    return (
      <Paper elevation={6}>
        <Link
          color="primary"
          onClick={() => {
            navigateToCharity(charity.id);
          }}
        >
          <Grid size={{ xs: 12 }} container>
            <Grid size={{ xs: 2 }}>
              <Avatar
                alt={charity.title}
                src={`${charity.logoImageUrl ? charity.logoImageUrl : consts.DEFAULT_CHARITYLOGOIMAGEURL}`}
                variant="square"
              />
            </Grid>
            <Grid size={{ xs: 10 }}>
              <Typography variant="body1" component="div">
                {`${charity.title}`}
              </Typography>
              <Typography variant="body1" component="div">
                {`${charity.id.slice(0, 2)}-${charity.id.slice(2)}`}
              </Typography>
            </Grid>
          </Grid>
        </Link>
      </Paper>
    );
  };

  const renderLink = () => {
    return (
      <Link
        color="primary"
        onClick={() => {
          navigateToCharity(charity.id);
        }}
      >
        <Typography variant="body1" component="div">
          {`Parent Org: ${charity.title}`}
        </Typography>
      </Link>
    );
  };

  if (charity) {
    switch (variant) {
      case 'full':
        return renderFull();
      case 'link':
        return renderLink();
    }
  } else {
    return null;
  }
};
